var Marionette = require('marionette')
var _ = require('lodash')

// -- select filter
var FilterSelectItem = Marionette.View.extend({
  template: require('../templates/filter-multi-select-item.html'),
  tagName: 'li',
  triggers: {
    'click': 'select:item'
  },
  onRender: function () {
    if (this.model.get('selected')) {
      this.el.classList.add('is-selected')
    } else {
      this.el.classList.remove('is-selected')
    }
  },
  modelEvents: {
    'change': 'render'
  }
})

var FilterSelect = Marionette.CollectionView.extend({
  tagName: 'ul',
  childView: FilterSelectItem,
  className: 'filter-popup__list',
  collectionEvents: {
    'add': 'collectionChange'
  },
  onChildviewSelectItem: function (args) {
    this.collection.each(function (model) {
      model.set('selected', false)
    })
    args.model.set('selected', true)
  },
  collectionChange: function () {
    this.trigger('updated', {})
  },
  onActivate: function () {
  }

})
module.exports = FilterSelect



// WEBPACK FOOTER //
// ./js/components/devices-filter/views/filter-select.js